import React, { useState, useEffect } from 'react';
import { Row, Col, Select, message, Checkbox} from "antd";
import { loadClassRoomDetails, getDivisionDetails } from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";
import {getFromCache, setCache} from "../../services/cache-service";

const ClassDivisionLoader = ({ onChange, classDivision, selectedClassDivision , isMultiple=false, onRemoveClassDivisions}) => {
  const [filters, setFilters] = useState({});
  const [classes, setClasses] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const[selectedIds, setSelectedIds] = useState()

  const loadClassRooms = () => {
    const cachedData = getFromCache('classDivisionData');

    if (cachedData) {
      setClasses(cachedData)
    } else {
      let reqObj = {
        condition: { companyId: global_var.company_id, activeFlag: 1 },
        projection: { className: 1, classCourseConfig: 1, fkClassRoomMasterId: 1, classAlias: 1 },
      };
  
      if (global_var.academicYearId) {
        reqObj.condition['academicYear'] = global_var.academicYearId
      }
  
      if (global_var.role_id === global_var.TEACHER_ROLE_ID) {
        reqObj.restrictClasses = true;
      }
  
      reqObj.rmId = global_var.roleMappingId;
  
      loadClassRoomDetails(reqObj)
        .then((response) => {
          let classes = JSON.parse(response.data);
          classes.forEach((class_) => {
            class_['_id'] = (class_['_id']['$oid'] ? class_['_id']['$oid'] : class_['_id']);
          });
          setClasses(classes);
          setCache('classDivisionData', classes)
        });

    }
    
  };

  const loadDivisions = (selectedClass) => {
    let divisionCondition = {
      companyId: global_var.company_id,
      classroomId: selectedClass,
      activeFlag: 1,
      rmId: global_var.roleMappingId,
    };

    if (global_var.academicYearId) {
      divisionCondition['academicYear'] = global_var.academicYearId
    }

    getDivisionDetails(divisionCondition)
      .then((response) => {
        if (response.data.statusCode === 200) {
          setDivisions(response.data.divisions);
        } else {
          message.error(response.data.message);
        }
    });
  };

  useEffect(() => {
    loadClassRooms();
  }, []);

  useEffect(() => {
    const newSelectedIds = selectedClassDivision? selectedClassDivision.map((division) => (division ? division.fkDivisionId : null)): null;
    setSelectedIds(newSelectedIds);
  }, [selectedClassDivision]);


  const isAllChecked = selectedIds? selectedIds.length === divisions.filter((d) => d._id !== "all").length : false;
  const handleCheckboxChange = (divisionId, checked) => {
    if (divisionId === "all") {
      if (checked) {

        const allDivisionIds = divisions.map((d) => d._id).filter((d) => d !== "all");
        setSelectedIds(allDivisionIds);

        allDivisionIds.forEach((id) => {
          handleDivisionChange(id);
        });
      } else {

        setSelectedIds([]);
        divisions.forEach((d) => {
          if (d._id !== "all") {
            onRemoveClassDivisions(d._id);
          }
        });
      }
    } else {

      const updatedSelectedIds = checked
        ? [...selectedIds, divisionId]
        : selectedIds.filter((id) => id !== divisionId);

      setSelectedIds(updatedSelectedIds);

      if (checked) {
        handleDivisionChange(divisionId);
      } else {
        onRemoveClassDivisions(divisionId);
      }
    }
  };

  const handleDivisionChange = (selectedDivisions) => {
    const selectedDivisionObject = divisions.find(division_ => division_._id === selectedDivisions);

    setSelectedDivision(selectedDivisions);
    setFilters(prevFilters => ({
      ...prevFilters,
      fkDivisionId: selectedDivisions,
      fkDivisionName: selectedDivisionObject?.divisionName || '',
    }));

    if (filters.fkClassId && selectedDivisions) {

      const selectedClassDivision = { ...filters, fkDivisionId: selectedDivisions, fkDivisionName: selectedDivisionObject?.divisionName || '' };
        if (onChange) {
          onChange(selectedClassDivision);
        }
    }
  };

  return (
    <Row className="mb-2">
      <Col span={10} style={{ marginRight: "8px" }}>
        <Select
          allowClear={true}
          style={{ width: "100%" }}
          placeholder="Filter by class"
          onChange={(selectedClass) => {
            const selectedClassObject = classes.find(class_ => class_._id === selectedClass);
            
            setFilters({
              fkClassId: selectedClass,
              fkClassName: selectedClassObject?.className || '',
              fkDivisionId: null,
              fkDivisionName: null,
            });

            if (selectedClass) {
              loadDivisions(selectedClass);
              setSelectedDivision(null);
            } else {
              setDivisions([]);
              setSelectedDivision(null);
            }
          }}
          options={classes.map((class_) => ({
            label: class_.classAlias,
            value: class_._id,
          }))}
          defaultValue={classDivision?.fkClassId || undefined}
        />
      </Col>
      
      <Col span={10}>
      
        {!isMultiple ? (
          <Select
          allowClear={true}
          style={{ width: "100%" }}
          placeholder="Filter by division"
          value={selectedDivision}
          onChange={handleDivisionChange}
          options={divisions.map((division_) => ({
            label: division_.divisionName,
            value: division_._id,
          }))}
          defaultValue={classDivision?.fkDivisionId || undefined}
          />
        ):(
          <Select
          style={{ width: "100%" }}
          placeholder="Filter by division"
          value={selectedIds}
          dropdownRender={(menu) => (
            <div style={{ maxHeight: "200px", overflowY: "auto", padding: "8px", scrollbarWidth: "none",msOverflowStyle: "none"}}>
              <div style={{maxWidth: '80px'}}>
              <Checkbox
                key="all"
                checked={isAllChecked}
                onChange={(e) => handleCheckboxChange("all", e.target.checked)}
              >
                <span style={{ marginLeft: "5px" }}>All</span>
              </Checkbox>
                {divisions.map((division_) => (
                  <Checkbox
                  key={division_._id}
                  checked={selectedIds.includes(division_._id)}
                  onChange={(e) => handleCheckboxChange(division_._id, e.target.checked)}
                  >
                    <span style={{marginLeft: '5px'}}>{division_.divisionName}</span>
                  </Checkbox>
                ))}
              </div>
            </div>
          )}
          options={divisions.map((division_) => ({
            label: division_.divisionName,
            value: division_._id,
          }))}
          defaultValue={selectedIds || undefined}
          />
        )}
      </Col>
    </Row>
  );
};

export default ClassDivisionLoader;
